export const DATE_FORMAT = {
  DDMMMYYYY: 'DD MMM YYYY',
  DDMMMYYYYHHmmss: 'DD MMM YYYY HH:mm:ss',
  DDMMMYYYYHHmm: 'DD MMM YYYY HH:mm',
  FULL_DATE: 'YYYY-MM-DD H:mm:ss ZZ'
};
